import { thingMoveEvent } from '@/play/things/things'

/** One drop of a block: its cells moved by a whole-cell offset (one undo step). */
export const LETTER_BLOCKS_MOVE = thingMoveEvent('experience.letter-blocks.move')

/** Reducer handlers for Letter blocks (`experience.letter-blocks.*`). */
export const eventHandlers = LETTER_BLOCKS_MOVE.handlers
